import React from 'react';

import ResourceList from '../ResourceSchedule/ResourceList';
import equipmentAxis from './equipmentAxis';
import { useEquipmentRowMap } from './useEquipmentRows';

export default function EquipmentList(props) {
  const rowMap = useEquipmentRowMap();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ResourceList axis={equipmentAxis} rowMap={rowMap} {...props} />
  );
}
